const initializeMpmConsentForm = (form) => {
  if (!form || form.dataset.mpmConsentInitialized === 'true') return;

  form.dataset.mpmConsentInitialized = 'true';

  const checkbox = form.querySelector('[data-mpm-consent-checkbox]');
  const submitButton = form.querySelector('[data-mpm-consent-submit]');
  const errorMessage = form.querySelector('[data-mpm-consent-error]');

  if (!checkbox || !submitButton) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!form.reportValidity()) return;

    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.dataset.originalLabel = submitButton.textContent;
    submitButton.textContent = 'Redirection sécurisée…';
    errorMessage.hidden = true;

    const routeRoot = window.Shopify?.routes?.root || '/';
    const variantId = Number(form.dataset.variantId);
    const consentTimestamp = new Date().toISOString();

    try {
      const clearResponse = await fetch(`${routeRoot}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
      });

      if (!clearResponse.ok) throw new Error('Cart clear failed');

      const addResponse = await fetch(`${routeRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                '_Accord contenu numérique': 'Oui – accès immédiat et renonciation au droit de rétractation',
                '_Consentement horodaté': consentTimestamp
              }
            }
          ]
        })
      });

      if (!addResponse.ok) throw new Error('Cart add failed');

      window.location.assign(`${routeRoot}checkout`);
    } catch (error) {
      errorMessage.hidden = false;
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitButton.textContent = submitButton.dataset.originalLabel;
    }
  });
};

const initializeAllMpmConsentForms = () => {
  document.querySelectorAll('[data-mpm-consent-form]').forEach(initializeMpmConsentForm);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllMpmConsentForms, { once: true });
} else {
  initializeAllMpmConsentForms();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeMpmConsentForm(event.target.querySelector('[data-mpm-consent-form]'));
});
